import './patientInsuranceViewEditComponent.scss'
import React, {useCallback, useEffect, useState} from 'react';
import {CommonService} from "../../../../../shared/services";
import InsuranceDetailsComponent
    from "../../../../../shared/components/insurance-details/insuranceDetailsComponent";
import StatusCardComponent from "../../../../../shared/components/status-card/statusCardComponent";
import {Grid} from "@mui/material";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import InsuranceFormComponent from "../../../../../shared/components/insurance-form/insuranceFormComponent";
import DrawerComponent from "../../../../../shared/components/drawer/drawerComponent";
import {IAPIResponseType} from "../../../../../shared/models/api.model";
import EditIcon from "@mui/icons-material/Edit";
import {ImageConfig} from "../../../../../constants";
import LottieFileGenarationComponent
    from "../../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";

interface PatientInsuranceViewComponentProps {
    patientID: string|undefined;
    canEdit: boolean;
}

const PatientInsuranceViewEditComponent = (props: PatientInsuranceViewComponentProps) => {
    const {patientID,canEdit} = props;
    const [openInsuranceDrawer, setOpenInsuranceDrawer] = useState<boolean>(false);
    const [insuranceMode, setInsuranceMode] = useState<string>("");
    const [patientInsuranceList, setPatientInsuranceList] = useState<any>([]);
    const [isPatientInsuranceListLoading, setIsPatientInsuranceListLoading] = useState<boolean>(false);
    const [isPatientInsuranceListLoaded, setIsPatientInsuranceListLoaded] = useState<boolean>(false);
    const [isPatientInsuranceListLoadingFailed, setIsPatientInsuranceListLoadingFailed] = useState<boolean>(false);
    const [insuranceInitialValues, setInsuranceInitialValues] = useState<any>("");

    const getPatientInsuranceList = useCallback(() => {
        setIsPatientInsuranceListLoading(true);
        setIsPatientInsuranceListLoaded(false);
        setIsPatientInsuranceListLoadingFailed(false);
        const payload = {}
        CommonService._patient.getPatientInsuranceList(patientID, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    const sortedList=CommonService.sortPatientInsuranceList(response.data);
                    setPatientInsuranceList(sortedList);
                }
                setIsPatientInsuranceListLoading(false);
                setIsPatientInsuranceListLoaded(true);
                setIsPatientInsuranceListLoadingFailed(false);
            })
            .catch((error: any) => {
                setIsPatientInsuranceListLoading(false);
                setIsPatientInsuranceListLoaded(false);
                setIsPatientInsuranceListLoadingFailed(true);
            });
    }, [patientID])

    useEffect(() => {
        if (patientID) {
            getPatientInsuranceList();
        }
    }, [patientID, getPatientInsuranceList]);

    const handleInsuranceDrawer = useCallback((insuranceMode: any, insurance?: any) => {
        if (insuranceMode === 'edit') {
            setInsuranceInitialValues(insurance);
            setInsuranceMode('edit');
        }
        if (insuranceMode === 'add') {
            setInsuranceMode('add');
        }
        setOpenInsuranceDrawer(true);
    }, []);
    const handleInsuranceDrawerClose = useCallback(() => {
        setInsuranceInitialValues("");
        setOpenInsuranceDrawer(false);
    }, []);

    const onUpdateComplete = useCallback((data: any) => {
        if (insuranceMode === 'add') {
            setPatientInsuranceList((oldState: any) => {
                if (oldState?.length > 0) {
                    return [...oldState, data]
                } else {
                    return [data]
                }
            });
        }
        if (insuranceMode === 'edit') {
            const temporaryList = patientInsuranceList;
            const index = temporaryList.findIndex((insuranceDetails: any) => {
                return insuranceDetails.id === data.id;
            });
            temporaryList[index] = data;
            setPatientInsuranceList(temporaryList);
        }
        setInsuranceInitialValues("");
        setOpenInsuranceDrawer(false);
    }, [insuranceMode, patientInsuranceList]);

    return (
        <div className="patient-insurance-component details-tab-data-content">
            {
                isPatientInsuranceListLoading && <div className="spinner-loading-wrapper">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isPatientInsuranceListLoadingFailed && <>
                    <StatusCardComponent title={"Patient details failed to load"}/>
                </>
            }
            {
                isPatientInsuranceListLoaded && <>
                    {patientInsuranceList.length === 0 ?
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <div className='patient-no-insurance-header'> No
                                    insurance
                                    have been added.
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                {
                                    canEdit &&
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"outlined"}
                                        fullWidth={true}
                                        handleClick={() => handleInsuranceDrawer("add")}
                                    >
                                        Add Insurance
                                    </ButtonComponent>
                                }
                            </Grid>
                        </Grid>
                        :
                        <>
                            {
                                patientInsuranceList?.map((insurance: any, index: any) => {
                                    return (
                                        <div className='patient-insurance-card-component'>
                                            <div key={CommonService.getUUID()}>
                                                <div
                                                    className='insurance-card-header-wrapper'>
                                                    <div>
                                                        {`Insurance ${index + 1}`}
                                                    </div>
                                                    {canEdit &&
                                                        <ButtonComponent
                                                            type={'button'}
                                                            variant={'outlined'}
                                                            handleClick={() => handleInsuranceDrawer("edit", insurance)}
                                                            startIcon={
                                                                <EditIcon/>}>Edit Details</ButtonComponent>
                                                    }

                                                </div>
                                                <>
                                                    <InsuranceDetailsComponent insuranceDetails={insurance} isAttachmentDownloadable={true}/>
                                                </>
                                            </div>
                                            {index<2 &&
                                                <div className="horizontal-line"/>
                                            }
                                        </div>
                                    )
                                })

                            }
                            {patientInsuranceList.length < 3 &&canEdit &&
                                <div className='add-insurance-button'
                                     onClick={() => handleInsuranceDrawer("add")}>
                                    + Add Insurance
                                </div>
                            }
                        </>
                    }
                </>
            }
            <DrawerComponent
                open={openInsuranceDrawer}
                closeOnBackDropClick={true}
                closeOnEsc={true}
                className={"drawer-wrapper"}
                onClose={() => handleInsuranceDrawerClose()}
            >

                        <InsuranceFormComponent
                            formInitialValues={insuranceInitialValues}
                            patientID={patientID}
                            formTitle={""}
                            insuranceMode={insuranceMode}
                            onUpdateComplete={(data: any) => onUpdateComplete(data)}
                        />

            </DrawerComponent>
        </div>
    )
};

export default PatientInsuranceViewEditComponent;
